import React from 'react'
import S3Upload from '@a4b/ui/src/modules/monetisation/puja/molecules/S3Upload'
import { Button, Col, Drawer, Form, Input, Row, Select, Switch } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { PUJA_PRESIGN_URL, YODA_CDN_URL } from '@/utils/constants'
import { DeleteOutlined, PlusCircleOutlined, DragOutlined } from '@ant-design/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

const { Option } = Select
interface Props {
  onClose: (fetchProducts: boolean) => void
  visible: boolean
  formSubmithandler: (values: any) => void
  form: any
  initialValues: any
  isEditJourney: boolean
}
const ItemCreation: React.FC<Props> = ({
  onClose,
  visible,
  formSubmithandler,
  form,
  initialValues,
  isEditJourney
}) => {
  const itemType = Form.useWatch('item_type', form);

  return (
    <Drawer
      title={isEditJourney ? 'Edit Product' : 'Create New Product'}
      placement='right'
      onClose={() => onClose(false)}
      visible={visible}
      destroyOnClose={true}
      width={800}
    >
      <Form
        form={form}
        layout='vertical'
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
      >
        <Form.Item
          label='Name of the Product'
          name='title'
          rules={[{ required: true, message: 'Please input item name!' }]}
        >
          <Input placeholder='Enter Name of the item' />
        </Form.Item>

        <Form.Item
          label='Description'
          name='description'
          rules={[{ required: true, message: 'Please input description!' }]}
        >
          <TextArea rows={4} placeholder='Enter description of the item' />
        </Form.Item>

        <Form.Item
          label='Product type'
          name='item_type'
          rules={[{ required: true, message: 'Please select item type!' }]}
        >
          <Select placeholder='Select type'>
            <Option value='item'>Item</Option>
            <Option value='astro'>Astro</Option>
            <Option value='prayer'>Prayer</Option>
            <Option value='pooja'>Pooja</Option>
            <Option value='sankalp'>Sankalp</Option>
          </Select>
        </Form.Item>


        <Form.Item
          label='Currency'
          name='currency'
          rules={[{ required: true, message: 'Please select currency!' }]}
        >
          <Select placeholder='Select currency'>
            <Option value='INR'>INR</Option>
            <Option value='USD'>USD</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label='Product price'
          name='price'
          rules={[{ required: true, message: 'Please input price of item!' }]}
        >
          <Input type='number' placeholder='Enter price' />
        </Form.Item>

        <Form.Item
          label='Slug'
          name='slug'
          rules={[{ required: true, message: 'Please input slug!' }]}
        >
          <Input placeholder='Enter slug' disabled={isEditJourney} />
        </Form.Item>

        {/* <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label='Language Code'
              name='language_code'
              rules={[{ required: true, message: 'Please input language code!' }]}
            >
              <Input placeholder='Enter language code' disabled />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label='Currency'
              name='currency'
              rules={[{ required: true, message: 'Please input currency!' }]}
            >
              <Input placeholder='Enter currency' disabled />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label='Country Code'
              name='country_code'
              rules={[{ required: true, message: 'Please input country code!' }]}
            >
              <Input placeholder='Enter country code' disabled />
            </Form.Item>
          </Col>
        </Row> */}

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label='Batch Size'
              name='batch_size'
              rules={[{ required: true, message: 'Please input batch size!' }]}
            >
              <Input type='number' placeholder='Enter batch size' />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label='Quantities'
              name='quantities'
              rules={[{ required: true, message: 'Please input quantities!' }]}
            >
              <Input type='number' placeholder='Enter quantities' />
            </Form.Item>
          </Col>

          {itemType === 'pooja' && (
            <Col span={8}>
              <Form.Item
                label='Member Size'
                name='member_size'
                rules={[{ required: true, message: 'Please input member size!' }]}
              >
                <Input type='number' placeholder='Enter member size' />
              </Form.Item>
            </Col>
          )}

        </Row>

        <Form.Item
          label='Main Image'
          name='image_url'
          valuePropName='fileList'
          rules={[
            {
              min: 1,
              max: 1,
              validator: async (rules: any, values: any) => {
                if (values?.length < rules.min) {
                  return Promise.reject('Main Image')
                }
              },
            },
          ]}
        >
          <S3Upload cdnUrl={YODA_CDN_URL} preSignUrl={PUJA_PRESIGN_URL} min={1} max={1} />
        </Form.Item>

        {/* <Col span={12}>
          <Form.Item
            label='Bottom sheet image'
            name='bottomsheet_image_url'
            valuePropName='fileList'
            rules={[
              {
                min: 1,
                max: 1,
                validator: async (rules: any, values: any) => {
                  if (values?.length < rules.min) {
                    return Promise.reject('Bottom sheet Image')
                  }
                },
              },
            ]}
          >
            <S3Upload
              cdnUrl={YODA_CDN_URL}
              preSignUrl={PUJA_PRESIGN_URL}
              min={1}
              max={1}
            />
          </Form.Item>
        </Col> */}

        <Form.Item
          label='Bottom Sheet Medias'
          name='bottomsheet_medias'
          style={{ marginTop: '50px' }}
          rules={[
            {
              required: true,
              min: 1,
              max: 10,
              validator: async (rules: any, values: any) => {
                if (values?.length < rules.min) {
                  return Promise.reject('Bottomsheet image')
                }
              },
            },
          ]}
          valuePropName='fileList'
        >
          <S3Upload
            cdnUrl={YODA_CDN_URL}
            preSignUrl={PUJA_PRESIGN_URL}
            min={1}
            max={10}
          />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col span={8}>
            {/* <Form.Item
              label='Is IGST Applicable?'
              name='is_igst'
              valuePropName='checked'
            // style={{ marginTop: '50px' }}
            >
              <Switch />
            </Form.Item> */}
          </Col>
          <Col span={8}>
            <Form.Item
              name="multi_add"
              label="Multi Add"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="deliverable"
              label="Deliverable"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        {/* IGST Applicable Toggle */}

        <Form.Item
          name="short_name"
          label="Short Name"
        >
          <Input placeholder="Enter short name" />
        </Form.Item>

        {/* HSN Code */}
        <Form.Item
          label='HSN Code'
          name='hsn_code'
        // rules={[
        //   { pattern: /^[0-9]{6,8}$/, message: 'HSN Code must be 6 to 8 digits!' },
        // ]}
        >
          <Input placeholder='Enter HSN Code' maxLength={8} />
        </Form.Item>

        {/* Tax Rate Percentage */}
        <Form.Item
          label="Tax Rate"
          name="tax_rate"
          rules={[
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === "") {
                  return Promise.resolve(); // Required validation will handle empty values
                }

                const numValue = Number(value);
                if (isNaN(numValue) || numValue < 0 || numValue > 100) {
                  return Promise.reject("Tax Rate % must be a valid number between 0 and 100!");
                }

                return Promise.resolve();
              }
            }
          ]}
        >
          <Input type="number" placeholder="Enter Tax Rate %" />
        </Form.Item>

        {itemType === 'pooja' && (
          <>
            <Form.Item
              label='Specificity'
              name='specificity'
            >
              <Input placeholder='Enter specificity' />
            </Form.Item>

            <Form.Item
              label='Bullet Icon'
              name='bullet_icon_url'
              valuePropName='fileList'
            >
              <S3Upload cdnUrl={YODA_CDN_URL} preSignUrl={PUJA_PRESIGN_URL} min={0} max={1} />
            </Form.Item>

            {/* Additional Info List */}
            <Row style={{ border: '1px solid #e0dcdc', padding: '10px', borderRadius: '1px' }}>
              <Form.List name={['additional_info_v2']}>
                {(fields, { add, remove, move }) => (
                  <DragDropContext
                    onDragEnd={({ source, destination }) => {
                      if (destination) {
                        move(source.index, destination.index);
                      }
                    }}
                  >
                    <Droppable droppableId="additional-info-list">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{ width: '100%' }}
                        >
                          {fields.map((field, index) => (
                            <Draggable
                              key={field.key}
                              draggableId={field.key.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    paddingRight: '12px',
                                    paddingTop: '10px'
                                  }}
                                >
                                  <div style={{ border: '1px dashed #e0dcdc', padding: '10px' }}>
                                    <Row justify="space-between" style={{ width: '100%' }}>
                                      <div {...provided.dragHandleProps} style={{ cursor: 'move', marginRight: '8px' }}>
                                        <DragOutlined />
                                      </div>
                                      <Form.Item
                                        label={`Point ${index + 1}`}
                                        name={[field.name]}
                                        labelCol={{ span: 28 }}
                                        wrapperCol={{ span: 28 }}
                                        style={{ flexBasis: '85%', marginBottom: '0px' }}
                                        rules={[
                                          {
                                            required: true,
                                            message: 'Enter Additional Info',
                                          },
                                        ]}
                                      >
                                        <TextArea rows={2} placeholder="Enter Additional Info" />
                                      </Form.Item>
                                      <Button
                                        onClick={() => remove(field.name)}
                                        type="ghost"
                                        icon={<DeleteOutlined />}
                                        size="middle"
                                        danger
                                        style={{ marginTop: '30px' }}
                                      />
                                    </Row>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                    <Col span={24} style={{ paddingTop: '15px' }}>
                      <Row justify="start">
                        <Col span={4}>
                          <Button
                            onClick={() => add()}
                            type="ghost"
                            icon={<PlusCircleOutlined />}
                            size="middle"
                          >
                            Add Additional Info
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </DragDropContext>
                )}
              </Form.List>
            </Row>
          </>
        )}

        <Form.Item
          name='id'
          rules={[{ required: false, message: 'Please input item id!' }]}
        >
          <Input placeholder='Enter id of the item' hidden />
        </Form.Item>

        <Form.Item style={{ paddingTop: 24 }}>
          <Button type='primary' onClick={formSubmithandler}>
            {isEditJourney ? 'Update Product' : "Create Product"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  )
}
export default ItemCreation
